<template>
    <div :style="{width, height}" class="statisDiv">
        <div class="headerClass">
            <div class="deparClass">员工姓名</div>
            <div class="otherClass service">手机号</div>
            <div class="otherClass service">负责区域</div>
            <div class="otherClass">销售等级</div>
            <div class="otherClass">订单总数</div>
            <div class="otherClass">客户总数</div>
        </div>
        <div class="departViewClass writeHearScroll">
            <div class="departItemClass" v-for="(item, index) in departArr" :key="index" @click="goDirector(item.admin_user_id)">
                <div class="deparClass whiteText">{{item.teacher_name}}</div>
                <div class="phoneClass">{{item.phone}}</div>
                <div class="serviceCountryClass">{{item.service_country_names}}</div>
                <div class="otherClass whiteText">{{item.level}}</div>
                <div class="otherClass whiteText">{{item.order_num}}</div>
                <div class="otherClass whiteText">{{item.customer_num}}</div>
                <img class="userIconClass" src="../src/assets/imgs/userIcon.png" alt="">
            </div>
            <img class="noDataImgClass" v-if="departArr.length == 0" src="../src/assets/imgs/noDataImg.png" />

        </div>
    </div>
</template>

<script>
export default {
    props: {
        width: String,
        height: String,
        backImg: String,
        totalText: String,
        companyName: String,
        describeText: String,
        departArr: Array
    },
    data(){
        return{

        }
    },
    methods: {
        goDirector(id){
            this.$emit('changeDire', id);
        }
    }
}
</script>

<style lang="scss" scoped>
.statisDiv{
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
}
.headerClass{
    display: flex;
    width: 100%;
    height: 26px;
}

.departViewClass{
    width: 100%;
    height: calc(100% - 30px);
    overflow-y: auto;
}
.departItemClass{
    margin-top: 8px;
    display: flex;
    width: 100%;
    min-height: 45px;
    max-height: 45px;
    background: linear-gradient(270deg, rgba(94,234,255,0) 0%, rgba(71,221,255,0.5) 49%, rgba(48,208,255,0) 100%);
    cursor: pointer;
}
.departItemClass:first-child{
    margin-top: 0;
}
.deparClass{
    display: flex;
    align-items: center;
    width: 16%;
    color: #13FFEE;
}
.phoneClass{
    display: flex;
    align-items: center;
    width: 16%;
    color: white;
    font-size: 14px;
}
.otherClass{
    // max-width: 16%;
    // min-width: 14%;
    width: 14%;
    display: flex;
    align-items: center;
    color: #13FFEE;
}
.whiteText{
    font-weight: 500;
    font-size: 14px;
    color: #FFFFFF;
}
.totalDivClass{
    display: flex;
    align-items: center;
    background-color: #FFFFFF;
}
.totalClass{
    margin-top: 2%;
    font-weight: bold;
    color: #13FFEE;
    text-align: left;
    font-size: 22px;
}
.companyClass{
    font-weight: 600;
    font-size: 14px;
    color: #13FFEE;
    margin-top: 20px;
}
.describeClass{
    margin-top: -4px;
    color: #FFFFFF;
    font-size: 15px;
    text-align: left;
}
.serviceCountryClass{
    margin-right: 6px;
    // max-width: 16%;
    // min-width: 14%;
    width: 16%;
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 14px;
    color: #FFFFFF;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    // background-color: #bfc7f3;
}
.service{
    margin-right: 10px;
}
.userIconClass{
    margin: auto 0;
    width: 20px;
    height: 20px;
    background-size: 100% 100%;
}
.noDataImgClass{
    margin: 10% auto;
    width: 88px;
    height: 88px;
    background-size: 100% 100%;
}
@media (max-width:768px){
	.statisDiv{
		width: 95%;
		margin: auto;
	}
	.phoneClass{
		font-size: 8px;
	}
	.serviceCountryClass{
		font-size: 10px;
		width: 33px;
		overflow: hidden;
	}
	.whiteText{
		font-size: 10px;
	}
	.otherClass{
		width: 11%;
	}
	.service{
		margin-right: -5px;
	}
}
</style>

<style lang="scss">
.writeHearScroll{
  &::-webkit-scrollbar {
    width: 6px;
    background: transparent;
  }

  &::-webkit-scrollbar-corner,
  /* 滚动条角落 */
  &::-webkit-scrollbar-thumb,
  &::-webkit-scrollbar-track {
    border-radius: 4px;
  }

  &::-webkit-scrollbar-corner,
  &::-webkit-scrollbar-track {
    /* 滚动条轨道 */
    background-color: #bfc7f3;
    box-shadow: inset 0 0 1px #e1e4f4;
  }

  &::-webkit-scrollbar-thumb {
    /* 滚动条手柄 */
    background-color: #797a7c;
  }
}
</style>